"use strict";


import agosoomcagoTitleIcon from "../../assets/images/index/agosoomcago.jpg";
import agosoomcagoNav from "../../assets/images/index/agosoomcago.jpg";

export const iconImage = () => {
  const agosoomcagoTITLEICON = document.getElementById("title-icon"); agosoomcagoTITLEICON.href = agosoomcagoTitleIcon;
  const agosoomcagoNAV = document.getElementById("navimg"); agosoomcagoNAV.src = agosoomcagoNav;
};